// @flow
import {
	WebComponent,
} from 'fg-frontend';
import $ from 'jquery';
import 'fg-frontend/plugins/jquery.webslider';

export default class Webslider extends WebComponent {
	didMount() {
		const {
			websliderData,
		} = this.props;

		$(this.element).webslider({
			data: websliderData || [],
			slideContentFormatter: function(data) {
				var result = '';
				result += '<ul class="webslider__container">';
				for (var i = 0; i < data.length; i++) {
					result += '<li class="webslider__item">';

					if (data[i].motive && data[i].motiveSm) {
						if (data[i].link) { result += `<a class="webslider__link" href="${data[i].link}">`; }
						result += `<picture>`;
						result += ` <source media="(max-width: 992px)" srcset="${data[i].motiveSm}">`;
						result += ` <img src="${data[i].motive}" alt="${data[i].title}" class="webslider__motive">`;
						result += `</picture>`;
						if (data[i].link) { result += `</a>`; }
					}
					result += '</li>';

				}
				result += '</ul>';
				return result;
			},
			controlArrows: false,
			controlPoints: true,
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/Webslider.js